import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function EmptyPayment({ description }) {
  return (
    <Stack
      alignItems="center"
      direction="column"
      py="40px"
      spacing="8px"
    >
      <Text
        color="secondary"
        size="xl"
        weight="medium"
      >
        {description}
      </Text>
    </Stack>
  );
}

EmptyPayment.propTypes = {
  description: PropTypes.string.isRequired
};
